import React from 'react'
import { useBrandingSettings } from '../../../hooks/branding'

import styles from './styles.sass'

export default function EmailConfirmationScreen({
  children,
}: React.PropsWithChildren) {
  const { landingPageImage, logoPrimary } = useBrandingSettings()

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img src={logoPrimary} />
        </div>
        <div>{children}</div>
        <div className={styles.copyright}>
          <div>Copyright &copy; Tickmark, Inc {new Date().getFullYear()}</div>
        </div>
      </div>
      <div className={styles.image}>
        <img src={landingPageImage} alt="A group of people around a laptop" />
      </div>
    </div>
  )
}
